import { render, staticRenderFns } from "./LoteExtraOpts.vue?vue&type=template&id=2024cc8c"
import script from "./LoteExtraOpts.vue?vue&type=script&lang=js"
export * from "./LoteExtraOpts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports